"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
const ValidationIssue_1 = __importDefault(require("./ValidationIssue"));
let ValidationError = class ValidationError extends Error {
    validationIssues = [];
    addIssue(modelType, errorCode, fieldName, value, path, issueType) {
        const validationIssue = new ValidationIssue_1.default(modelType, errorCode, fieldName, value, path, issueType);
        this.validationIssues.push(validationIssue);
        this.message = `${this.validationIssues.length} issue(s) found`;
        return validationIssue;
    }
    addValidationIssue(issue) {
        this.validationIssues.push(issue);
        this.message = `${this.validationIssues.length} issue(s) found`;
    }
    addValidationIssueList(issues) {
        this.validationIssues.push(...issues);
        this.message = `${this.validationIssues.length} issue(s) found`;
    }
};
__decorate([
    (0, openapi_1.Schema)({
        type: 'array',
        items: (0, openapi_1.ref)(() => ValidationIssue_1.default),
        description: 'Array containing all ValidationIssue instances identified by the schema',
    })
], ValidationError.prototype, "validationIssues", void 0);
ValidationError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown by a Validator when the body data is incorrectly structured',
    })
], ValidationError);
exports.default = ValidationError;
